"use client"

import { useState } from "react"

/** The Google iframe stays unloaded until the patient asks for it. */
export function MapEmbed({
  embedUrl,
  externalUrl,
  privacyTitle,
  privacyText,
  loadMapLabel,
  openMapsLabel,
}: {
  embedUrl: string
  externalUrl: string
  privacyTitle: string
  privacyText: string
  loadMapLabel: string
  openMapsLabel: string
}) {
  const [loaded, setLoaded] = useState(false)

  if (loaded) {
    return (
      <iframe
        src={embedUrl}
        className="h-[340px] w-full border-0"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Mapa do consultório do Dr. Filipe Cini, na Avenida Cândido Hartmann, 570"
        allowFullScreen
      />
    )
  }

  return (
    <div className="flex h-[340px] w-full flex-col items-center justify-center gap-4 border border-rule px-6 text-center">
      <p className="text-body font-semibold text-ink">{privacyTitle}</p>
      <p className="max-w-xs text-small text-ink-soft">{privacyText}</p>
      <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
        <button
          type="button"
          onClick={() => setLoaded(true)}
          className="inline-flex min-h-11 items-center bg-ink px-5 text-small font-semibold text-paper transition-opacity hover:opacity-90"
        >
          {loadMapLabel}
        </button>
        <a
          href={externalUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex min-h-11 items-center text-small text-walnut underline underline-offset-4 transition-colors hover:text-walnut-dark"
        >
          {openMapsLabel}
        </a>
      </div>
    </div>
  )
}
